import React from 'react';
import classNames from 'classnames';
import { getCsrfToken } from 'utils';
import { urls } from 'app-constants';
import { useUserContext } from 'context';
import Icon from 'components/Icon';

const CurrentVenueToggle = () => {
  const { producerQuotas, fetchUserContext } = useUserContext();

  if (!producerQuotas?.length) return null;
  const multiple = producerQuotas.length > 1;

  const setCurrent = id => {
    fetch(urls.producerToggleActiveVenue, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'X-CSRFToken': getCsrfToken(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id }),
    })
      .then(response => {
        if (!response.ok) throw new Error(response.statusText);
        fetchUserContext();
      })
      .catch(err => {
        console.error(err);
      });
  };

  return producerQuotas.map(({ poi, isCurrentActive }) => {
    const handleClick = () => {
      if (multiple && !isCurrentActive) {
        setCurrent(poi.id);
      }
    };

    const classes = classNames({
      'dashboard-sidebar-label': true,
      active: multiple && isCurrentActive,
      toggle: multiple && !isCurrentActive,
    });

    return (
      <div key={poi.id} className={classes} onClick={handleClick}>
        <Icon i={['far', 'building']} />
        <span>{ poi.name }</span>
      </div>
    );
  });
};

export default CurrentVenueToggle;
